<div class="zip-page">
  <!-- Header -->
  <div class="flex items-center justify-between flex-wrap gap-4 mb-8">
    <div>
      <h1 class="text-2xl font-bold text-slate-900 tracking-tight">Export Flows</h1>
      <p class="text-sm text-slate-500 mt-1">Bulk-download every flow definition in the current environment as a single ZIP archive.</p>
      <p class="text-xs text-slate-400 mt-1">
        Export Flows is a <span class="pro-box"></span> subscription feature.
      </p>
    </div>
    <a href="https://learn.flowstudio.app/bulk-export-flows" target="learn"
      class="inline-flex items-center gap-2 text-sm font-medium text-brand hover:underline">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg>
      Learn about Bulk Export
    </a>
  </div>

  <!-- Form card -->
  <section class="mb-10 bg-white rounded-xl shadow-sm p-6" kendoTooltip>
    <h2 class="text-lg font-semibold text-slate-800 mb-4">Export to ZIP</h2>

    <div class="mb-5">
      <label class="block text-sm font-medium text-slate-700 mb-1.5">Filename pattern</label>
      <kendo-dropdownlist class="w-full max-w-md"
        [data]="['flow-display-name.json', 'flow-guid-name.json', 'flow-guid-display-name.json']"
        [(ngModel)]="filenametype"
        >
        <ng-template kendoDropDownListItemTemplate let-dataItem>
          <div class="template">{{ dataItem }}
            @if (dataItem == 'flow-display-name.json') {
              <div class="text-xs italic text-slate-500">flow name.json</div>
            }
            @if (dataItem == 'flow-guid-name.json') {
              <div class="text-xs italic text-slate-500">00000000-0000-0000-0000-00000000.json</div>
            }
            @if (dataItem == 'flow-guid-display-name.json') {
              <div class="text-xs italic text-slate-500">00000000-0000-0000-0000-00000000-flow name.json</div>
            }
          </div>
        </ng-template>
      </kendo-dropdownlist>
    </div>

    <button type="button"
      class="inline-flex items-center gap-1.5 rounded-lg shadow border-0 cursor-pointer px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600"
      [disabled]="!this.loaded"
      (click)="exportZip()">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/></svg>
      <span>Export ZIP</span>
    </button>
  </section>

  <!-- Results -->
  @if ((this.results | async).length > 0) {
    <section class="bg-white rounded-xl shadow-sm p-6">
      <h2 class="text-lg font-semibold text-slate-800 mb-3">Export results</h2>
      <ul class="space-y-1 text-sm text-slate-600 font-mono max-h-96 overflow-y-auto">
        @for (result of this.results | async; track result) {
          <li class="break-all">{{result}}</li>
        }
      </ul>
    </section>
  }
</div>
